'use client'

import { MouseEvent } from 'react'

import { useSafeBack } from '@/shared/lib'
import { Icon } from '@/shared/ui'

type Props = {
  label?: string
  className?: string
  onClick?: (event: MouseEvent) => void
}

export const CloseButton = ({ label = '닫기', className, onClick }: Props) => {
  const { goBack } = useSafeBack()

  const handleClick = (event: MouseEvent) => {
    if (onClick) {
      onClick(event)

      return
    }

    goBack()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={label}
      className={className}
    >
      <Icon name="close" size={24} strokeWidth={1.5} />
      <span className="sr-only">{label}</span>
    </button>
  )
}
